import { render, staticRenderFns } from "./benefits-collapsible-section.vue?vue&type=template&id=300a5273&scoped=true"
import script from "./benefits-collapsible-section.vue?vue&type=script&lang=js"
export * from "./benefits-collapsible-section.vue?vue&type=script&lang=js"
import style0 from "./benefits-collapsible-section.vue?vue&type=style&index=0&id=300a5273&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "300a5273",
  null
  
)

export default component.exports